import * as React from 'react';
import { useGenericState } from 'src/Library/UseGenericState';

interface EntityOptions {
    show: (cb?: (updatedState: any) => void, initState?: any) => void;
    hide: (cb?: (updatedState: any) => void, initState?: any) => void;
    isVisible: boolean;
}

const useVisibility = <Entity extends string>(entities: readonly Entity[]) => {
  const initialState = entities.map(e => false);

  const [state, setState] =  useGenericState(initialState);

  const updateVisibility = (index, isVisible, cb?: (updatedState: any) => void, initState?: typeof initialState) => {
    const newState = Object.assign([], initState || state, {[index]: isVisible});
    setState(newState, cb);
  };

  const populateEntity = (acc, e: string, i) => {
    acc[e] = {
      isVisible: state[i],
      show: (cb, initState) => updateVisibility(i, true, cb, initState),
      hide: (cb, initState) => updateVisibility(i, false, cb, initState),
    };
    return acc;
  };

  return entities.reduce(populateEntity, {}) as {
    [K in typeof entities[number]]: EntityOptions;
  };
};

export default useVisibility;
